import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainsPipeModule } from './contains';
import { DeferredPipeModule } from './deferred';
import { EmptyToEndPipeModule } from './empty-to-end';
import { FlightDatePipeModule } from './flight-date';
import { FlightNumberPipeModule } from './flight-number';
import { NaturalSortPipeModule } from './natural-sort';
import { OrderByPipeModule } from './order-by';
import { SafeHtmlPipeModule } from './safe-html';
import { SortPipeModule } from './sort';
import { SortByPipeModule } from './sort-by';
import { UniquePipeModule } from './unique';
import { UserIdPipeModule } from './userId';

@NgModule({
  imports: [
    CommonModule,
    EmptyToEndPipeModule,
    ContainsPipeModule,
    SortByPipeModule,
    SortPipeModule,
    OrderByPipeModule,
    NaturalSortPipeModule,
    UniquePipeModule,
    DeferredPipeModule,
    SafeHtmlPipeModule,
    UserIdPipeModule,
    FlightNumberPipeModule,
    FlightDatePipeModule,
  ],
  exports: [
    EmptyToEndPipeModule,
    ContainsPipeModule,
    SortByPipeModule,
    SortPipeModule,
    OrderByPipeModule,
    NaturalSortPipeModule,
    UniquePipeModule,
    DeferredPipeModule,
    SafeHtmlPipeModule,
    UserIdPipeModule,
    FlightNumberPipeModule,
    FlightDatePipeModule,
  ]
})
export class PipesModule { }
